import { render, staticRenderFns } from "./MutationEvent.vue?vue&type=template&id=36ce621e&scoped=true&"
import script from "./MutationEvent.vue?vue&type=script&lang=js&"
export * from "./MutationEvent.vue?vue&type=script&lang=js&"
import style0 from "./MutationEvent.vue?vue&type=style&index=0&id=36ce621e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ce621e",
  null
  
)

export default component.exports